"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeightAndBoxPeopleQuantity = exports.getBoxPeopleQuantity = void 0;
var Formatting_1 = require("../../Formatting");
var ProductPackaging_1 = require("./ProductPackaging");
var getBoxPeopleQuantity = function (item, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.format, format = _c === void 0 ? 'short' : _c;
    var shortFormat = format === 'short' ? 'pers.' : 'personne';
    var pluralFormat = format === 'short' ? 'pers.' : 'personnes';
    var str = item.minPeople && item.maxPeople && item.minPeople !== item.maxPeople ? "".concat(item.minPeople, " \u00E0 ") : '';
    str += (0, Formatting_1.pluralize)(item.maxPeople || item.minPeople, shortFormat, pluralFormat);
    return str;
};
exports.getBoxPeopleQuantity = getBoxPeopleQuantity;
var getWeightAndBoxPeopleQuantity = function (item, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.format, format = _c === void 0 ? 'short' : _c;
    var str = (0, ProductPackaging_1.getProductPackagingWeight)(item, { format: format });
    if (item.minPeople || item.maxPeople) {
        str += str ? ' - ' : '';
        str += (0, exports.getBoxPeopleQuantity)(item, { format: format });
    }
    return str;
};
exports.getWeightAndBoxPeopleQuantity = getWeightAndBoxPeopleQuantity;
exports.default = { getBoxPeopleQuantity: exports.getBoxPeopleQuantity, getWeightAndBoxPeopleQuantity: exports.getWeightAndBoxPeopleQuantity };
//# sourceMappingURL=BoxQuantity.js.map